import { api } from '@services';

import TagCategory, {
  ITagCategory,
  ITagCategoryApiModelWithTags,
} from '@models/TagCategory.model';

const indexTagsCategory = async (): Promise<ITagCategory[]> => {
  const { data: tagsCategory } = await api.get<ITagCategoryApiModelWithTags[]>(
    '/tagsCategory',
  );

  return TagCategory.arrayFromApiModelWithTags(tagsCategory);
};

export { indexTagsCategory };
